module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-aversion"
  }, [_c('topNav', {
    attrs: {
      "title": "版本信息",
      "url": "/opera/center",
      "replace": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title",
    on: {
      "click": _vm.goDetail
    }
  }, [(_vm.iconUrl) ? _c('img', {
    attrs: {
      "src": _vm.iconUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("版本号：" + _vm._s(_vm.version))])]), _vm._v(" "), _c('div', {
    staticClass: "infoList",
    on: {
      "click": _vm.goDetail
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.disVersion) ? _c('div', {
    staticClass: "ver"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/newLogo.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("© 2014-2025 ihotel.cn. All rights reserved.")])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "tip"
  }, [_c('li', [_vm._v("1、全新界面风格，采用类支付宝App首页的可定义功能按钮。\n\t\t\t\t\t"), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/homeSnap.png")
    }
  })])]), _vm._v(" "), _c('li', [_vm._v("2、增加消息模块，第一时间接收到有用的通知。.")]), _vm._v(" "), _c('li', [_vm._v("3、增加事件预警、对酒店关键指标可预警提醒。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c9382734","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/version.vue
// module id = 1838
// module chunks = 107